import { connect } from 'react-redux'

import { showModal } from 'redux/modules/modals'
import {
  addProduct,
  removeProduct,
  changeReduc,
  clearSelectedProducts
} from 'redux/modules/selectedProducts'

import ProductsComponent from '../components/ProductsComponent'

const mapActionCreators = {
  addProduct,
  removeProduct,
  changeReduc,
  clearSelectedProducts,
  showModal
}

const mapStateToProps = state => ({
  consos: state.consos.list,
  products: state.products.list,
  categories: state.categories.list,
  selectedProducts: state.selectedProducts.list,
  tables: state.tables.list,
  map: state.settings.size
})

export default connect(mapStateToProps, mapActionCreators)(ProductsComponent)



// WEBPACK FOOTER //
// ./src/routes/Products/containers/ProductsContainer.js